import { ValueOf } from '../types';

export const ConnectionStatus = {
  UNINITIALIZED: 'UNINITIALIZED',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  FAILED_TO_CONNECT: 'FAILED_TO_CONNECT',
  DISCONNECTING: 'DISCONNECTING',
  DISCONNECTED: 'DISCONNECTED',
} as const;

export type ConnectionStatus = ValueOf<typeof ConnectionStatus>;

export class ConnectionStateManager {
  static #instance: ConnectionStateManager;
  #status: ConnectionStatus = ConnectionStatus.UNINITIALIZED;

  private constructor() {}

  public static getInstance = (): ConnectionStateManager => {
    if (!ConnectionStateManager.#instance) {
      ConnectionStateManager.#instance = new ConnectionStateManager();
    }
    return ConnectionStateManager.#instance;
  };

  public getStatus = (): ConnectionStatus => this.#status;

  public setStatus = (status: ConnectionStatus): void => {
    this.#status = status;
  };

  public canDisconnect = (): boolean =>
    (
      [
        ConnectionStatus.CONNECTED,
        ConnectionStatus.CONNECTING,
      ] as ConnectionStatus[]
    ).includes(this.#status);

  public canConnect = (): boolean =>
    (
      [
        ConnectionStatus.UNINITIALIZED,
        ConnectionStatus.DISCONNECTED,
        ConnectionStatus.FAILED_TO_CONNECT,
      ] as ConnectionStatus[]
    ).includes(this.#status);
}
